import Head from 'next/head';
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import pflegeImage from '../public/images/Gut_fuer_dich.png';
import { NavBar } from 'components/shared/NavBar';

import TestBild from '../public/images/Leistungen_Service.jpg';

const Page = () => {
	return (
		<>
			<Head>
				<title>Service | Siccro Active Service</title>
				<meta
					name="description"
					content="Gereinigte Fenster sind eine gute Basis für ein angenehmes Wohnumfeld. Experten von SICCRO empfehlen, zusätzlich einige Pflegemaßnahmen durchzuführen, weil diese sich positiv auf die Lebensdauer auswirken und Ihnen dadurch Kosten sparen."
				/>
			</Head>
			<NavBar />
			<div className="mt-28 container text-4xl text-center md:pt-12 font-black  md:text-5xl mx-auto">
				<h1>Service für Fenster, Türen und Sonnenschutz</h1>
			</div>
			<div className=" max-w-[900px] text-xl pt-10 px-30 text-center flex flex-col mx-auto">
				<p>
					Möchte das Fenster nicht mehr richtig schließen, kommen kühle Luft, Feuchtigkeit und Lärm
					ungehindert hinein. Lässt es sich nicht mehr öffnen, steigt die Schimmelgefahr, während die frische
					Luft draußen bleibt. Fenster müssen im Wohnbereich daher jederzeit einwandfrei funktionieren. Doch
					das ist nicht immer gewährleistet.
				</p>
				<div className="flex flex-col pt-8">
					<Image src={TestBild} className="w-full rounded-md" height="300px" objectFit="cover" />
					<div className="w-full">
						<h2 className="text-2xl py-5 font-black">Wie oft sollte gewartet werden?</h2>
						<p>
							Ein gewisser Wartungsaufwand besteht bei allen Fenstern & Türen. Es lohnt sich, die Arbeiten
							regelmäßig ausführen zu lassen und auf einen professionellen Dienstleister zu setzen. Sie
							kennen sich mit allen Modellen und ihren Tücken aus, außerdem wissen sie bei vielen
							Problemen eine Lösung. Mindestens einmal pro Jahr sollte ein Tür- und Fensterservice
							durchgeführt werden. Der regelmäßige Service schützt vor teuren Reparaturen!
						</p>
					</div>
				</div>
				<div className=" max-w-[900px] text-2xl pt-5 px-5 font-black flex flex-col mx-auto">
					Gängige Wartungsarbeiten sind:
				</div>
				<div className="flex flex-col md:flex-row mt-5 md:mt-5 space-y-6 space-x-0 md:space-y-0 md:space-x-6">
					<div className="w-full md:w-2/2 pb-3 md:pb-12">
						<ul className="list-disc list-inside font-sub text-base space-y-3">
							<li>Kontrolle der Beschläge</li>
							<li>Nachjustieren der Flügel</li>
							<li>Prüfen der Schließzapfen</li>
							<li>Nachziehen der Schraubverbindungen</li>
							<li>Entfernen alter Schmierstoffe</li>
							<li>Schmieren und Ölen</li>
						</ul>
					</div>
				</div>
				<div className="mx-auto flex  justify-center">
					<Link href="/angebot" passHref>
						<button className="mt-9 w-full md:w-2/8 mb-20 select-none font-heading bg-primary p-3 rounded-md text-white text-lg shadow-md hover:shadow-lg hover:bg-primary-light focus:shadow-sm focus:outline-none active:shadow-inner transition-all active:bg-primary-dark duration-150">
							Angebot einholen
						</button>
					</Link>
				</div>
			</div>
		</>
	);
};

export default Page;
